import api from './axiosConfig';
import {
  CreateNotificationRequest,
  NotificationListResponse,
  NotificationPreference,
} from '../types';

export const notificationApi = {
  create: async (payload: CreateNotificationRequest): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/notifications', payload);
    return response.data;
  },

  getMyNotifications: async (params?: {
    pageNumber?: number;
    pageSize?: number;
    type?: string;
    isRead?: boolean;
  }): Promise<NotificationListResponse> => {
    const response = await api.get<NotificationListResponse>('/notifications/me', { params });
    return response.data;
  },

  markAsRead: async (id: string): Promise<void> => {
    await api.put(`/notifications/read/${id}`);
  },

  getMyPreferences: async (): Promise<NotificationPreference> => {
    const response = await api.get<NotificationPreference>('/notifications/preferences/me');
    return response.data;
  },

  updateMyPreferences: async (payload: NotificationPreference): Promise<void> => {
    await api.put('/notifications/preferences/me', payload);
  },
};
